export default {"src":"/_next/static/media/anue-hot-news.5970352c.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};